import axios from 'axios'

const SET_PRODUCTS = 'SET_PRODUCTS'
const SET_CEMENT_IDS = 'SET_CEMENT_IDS'
const SET_AGGREGATE_IDS = 'SET_AGGREGATE_IDS'
const SET_TYPES = 'SET_TYPES'
const SET_TIMESTAMP = 'SET_TIMESTAMP'

/**
 * Vuex state for product module
 * @type {Object}
 */
const state = {
    products: [],
    cements: [],
    aggregates: [],
    types: [],
    timestamp: null,
}

/**
 * Vuex mutations for product module
 * @type {Object}
 */
const mutations = {
    [SET_PRODUCTS]: (state, payload) => {
        state.products = payload
    },

    [SET_TYPES]: (state, payload) => {
        state.types = payload
    },

    [SET_CEMENT_IDS]: (state, payload) => {
        state.cements = payload
    },

    [SET_AGGREGATE_IDS]: (state, payload) => {
        state.aggregates = payload
    },

    [SET_TIMESTAMP]: (state, payload) => {
        state.timestamp = payload
    },
}

/**
 * Vuex actions for product module
 * @type {Object}
 */
const actions = {
    async fetchProducts({ commit, dispatch }, payload) {
        if (!payload?.backgroundFetch) {
            dispatch('wait/start', 'product.fetchProducts', { root: true })
        }

        const { data } = await axios.get('/api/products')
        commit(SET_PRODUCTS, data.products)
        commit(SET_TYPES, data.types)
        commit(SET_TIMESTAMP, data.timestamp)

        const cementIds = data.products
            .filter((e) => e.is_concrete)
            .map((e) => parseInt(e.id))
        const aggregateIds = data.products
            .filter((e) => !e.is_concrete)
            .map((e) => parseInt(e.id))
        commit(SET_CEMENT_IDS, cementIds)
        commit(SET_AGGREGATE_IDS, aggregateIds)

        if (!payload?.backgroundFetch) {
            dispatch('wait/end', 'product.fetchProducts', { root: true })
        }

        return data
    },
}

/**
 * Vuex getters for product module
 * @type {Object}
 */
const getters = {
    products: (state) => state.products,
    types: (state) => state.types,
    cements: (state) => state.cements,
    aggregates: (state) => state.aggregates,
    products_timestamp: (state) => state.timestamp,
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
